"use strict";

var getEnvironDomain = require("../getEnvironDomain-7b7a3c84.js");
module.exports = getEnvironDomain.getEnvironDomain;